'use strict';

import {BaseElement} from "../../interfaces/BaseElement";
import {isDev, settingsData, threeJsVariables} from "../../../settings";
import {ViewMode} from "../../../common";
import {getCurrentCameraDistance} from "../../controls/orbitControls";

export class ConfigInformer {
	constructor() {
		if (!isDev)
			return;

		const self = this;

		document.addEventListener('keydown', function (event) {
			if (event.ctrlKey && event.altKey && event.key === 'p') {
				document.removeEventListener('keydown', cylinderClearSettingsHandler);
				switch (settingsData.activeViewMode) {
					case ViewMode.Orbit:
						self.cameraPosition;
						break;
					case ViewMode.Cylinder:
						document.addEventListener('keydown', cylinderClearSettingsHandler);
						self.cylinderCameraLimits;
						break;
					case ViewMode.FloorPlan:
						document.addEventListener('keydown', keyplanClearSettingsHandler);
						self.keyplanCameraLimits;
						break;
				}
			}
		});

		function cylinderClearSettingsHandler(event) {
			if (event.ctrlKey && event.altKey && event.key === 'c') {
				console.log('%cCylinder limits are set to the debug values', 'color: palegreen');
				config.threejs.orbitControls.cylinder.desktop.min = 0;
				config.threejs.orbitControls.cylinder.desktop.max = 500;
			}
		}

		function keyplanClearSettingsHandler(event) {
			if (event.ctrlKey && event.altKey && event.key === 'c') {
				console.log('%cKeyplan limits are set to the debug values', 'color: palegreen');
				config.threejs.orbitControls.floorplan.desktop.min = 10;
				config.threejs.orbitControls.floorplan.desktop.max = 500;
			}
		}
	}

	get cameraPosition() {
		new InformerWindow(`
			<pre>
				Camera x: ${threeJsVariables.perspectiveCamera.position.x}
				Camera y: ${threeJsVariables.perspectiveCamera.position.y}
				Camera z: ${threeJsVariables.perspectiveCamera.position.z}
						
				Orbit x: ${threeJsVariables.orbitControls.target.x}
				Orbit y: ${threeJsVariables.orbitControls.target.y}
				Orbit z: ${threeJsVariables.orbitControls.target.z}
			</pre>
		`);
	}

	get cylinderCameraLimits() {
		new InformerWindow(`
			<pre>
				Camera distance: ${getCurrentCameraDistance()}
			</pre>
		`);
	}

	get keyplanCameraLimits() {
		new InformerWindow(`
			<pre>
				Camera distance: ${getCurrentCameraDistance()}
			</pre>
		`);
	}
}

class InformerWindow {
	#rootElement;
	#content;

	constructor(content) {
		this.#content = content;
		this.#rootElement = this.#create();
	}

	#create() {
		const window = new BaseElement()
			.addStyle('position', 'fixed')
			.addStyle('z-index', Infinity)
			.addStyle('top', '50%')
			.addStyle('left', '50%')
			.addStyle('background-color', 'black')
			.addStyle('color', 'green')
			.addStyle('font-weight', '700')
			.addStyle('padding', '10px')
			.addStyle('border-radius', '10px')
			.addStyle('font-size', '20px')
			.innerHtml(this.#content)
			.appendTo(document.body);
		new BaseElement()
			.addClass('close-button-cross')
			.event('click', () => window.remove())
			.appendTo(window.DOMElement);

		return window;
	}
}